var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConditionsTooltipDot = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 5.6,
    height: 5.6,
    viewBox: "0 0 5.6 5.6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "bg",
    cx: 2.8,
    cy: 2.8,
    r: 2.8,
    fill: "#FFE6D0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConditionsTooltipDot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/conditions-tooltip-dot.29c0614a04f0d32fffd205c22ab9e64d.svg";